import { gql } from '@apollo/client';

export const GET_BUSINESS_PARTNER = gql`
  query GetBusiness($partnerId: Int!) {
    business(id: $partnerId) {
      id
      companyName
      sector
      logo
      contactName
      contactLastName
      contactPhone
      contactPosition
      address
      city
      country
      email
      website
      description
      isActive
      createdAt
      updatedAt
      agency {
        id
        name
        logo
      }
    }
  }
`;

export const GET_PARTNER_OFFERS = gql`
  query GetBusinessOffers($businessId: Int!) {
    businessOffers(businessId: $businessId) {
      id
      title
      description
      validUntil
      discount
      minimumParticipants
      status
      package {
        id
        title
        description
        image
        formulas {
          id
          name
          hotels {
            id
            name
            stars
            bookingUrl
          }
        }
        itinerary {
          id
          dayNumber
          title
          description
        }
      }
      bookings {
        id
        travelerInfo {
          firstName
          lastName
          email
          phone
          passport {
            number
            expiryDate
          }
        }
        roomPreferences {
          type
          quantity
        }
        status
        createdAt
      }
      acceptedClients {
        id
        firstName
        lastName
        email
        phone
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_BUSINESS = gql`
  query GetBusiness($id: Int!) {
    business(id: $id) {
      id
      companyName
      sector
      logo
      contactName
      contactLastName
      contactPhone
      contactPosition
      address
      city
      country
      email
      website
      description
      isActive
      createdAt
      updatedAt
      agency {
        id
        name
        logo
      }
    }
  }
`;

export const GET_BUSINESS_OFFERS = gql`
  query GetBusinessOffers($businessId: Int!) {
    businessOffers(businessId: $businessId) {
      id
      title
      description
      validUntil
      discount
      minimumParticipants
      status
      business {
        id
        companyName
      }
      package {
        id
        title
        description
        image
        included
        countries
        type
      }
      bookings {
        id
        travelerInfo {
          firstName
          lastName
          email
          phone
          passport {
            number
            expiryDate
            file
          }
        }
        roomPreferences {
          type
          quantity
        }
        status
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_BUSINESSES = gql`
  query GetBusinesses($agencyName: String!) {
    businesses(agencyName: $agencyName) {
      id
      companyName
      sector
      logo
      contactName
      contactLastName
      contactPhone
      contactPosition
      address
      city
      country
      email
      website
      description
      isActive
      createdAt
      updatedAt
      agency {
        id
        name
        logo
      }
    }
  }
`;

export const GET_OFFER_BASIC_DETAILS = gql`
  query GetOfferBasicDetails($offerId: Int!) {
    businessOffer(id: $offerId) {
      id
      title
      description
      validUntil
      discount
      minimumParticipants
      status
      business {
        id
        companyName
      }
      package {
        id
        title
        description
        image
        included
        countries
        type
      }
      bookings {
        id
        travelerInfo {
          firstName
          lastName
          email
          phone
          passport {
            number
            expiryDate
            file
          }
        }
        roomPreferences {
          type
          quantity
        }
        status
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_OFFER_COMPLETE_DETAILS = gql`
  query GetOfferCompleteDetails($offerId: Int!) {
    businessOffer(id: $offerId) {
      id
      title
      description
      validUntil
      discount
      minimumParticipants
      status
      business {
        id
        companyName
      }
      package {
        id
        title
        description
        image
        groupSize
        category
        type
        departure
        departures {
          id
          departureDate
          returnDate
        }
        highlights
        included
        excluded
        cities
        countries
        formulas {
          id
          name
          priceType
          perPersonPrice
          roomPrices {
            single
            double
            triple
            quadruple
            quintuple
          childWithBed
          childWithoutBed
          baby
          }
          maxPersons
          isActive
        }
        itinerary {
          dayNumber
          title
          description
          activities
          meals {
            breakfast
            lunch
            dinner
          }
          accommodation
        }
      }
      bookings {
        id
        travelerInfo {
          firstName
          lastName
          email
          phone
          passport {
            number
            expiryDate
            file
          }
        }
        roomPreferences {
          type
          quantity
        }
        status
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_OFFER_ACCEPTED_CLIENTS = gql`
  query GetOfferAcceptedClients($offerId: Int!) {
    businessOffer(id: $offerId) {
      id
      acceptedClients {
        id
        firstName
        lastName
        email
        phone
      }
      rooms {
        id
        type
        capacity
        assignments {
          id
          client {
            id
            firstName
            lastName
            email
            phone
          }
        }
      }
    }
  }
`; 